import { useNavigate } from "@tanstack/react-router";
import { api } from "../api.js";
import { useResource } from "../useResource.js";
import { Playlist, type PlaylistDetail } from "./Playlist.js";
import { Failed, Loading } from "./Loading.js";

/**
 * One saved playlist, wired.
 *
 * `Regenerate` hands the recipe to the generator rather than running it here, and that is not
 * plumbing convenience: §J15's result screen states the outcome before showing anything and
 * offers the relaxation when a constraint bit. A regenerate that quietly saved a shorter list
 * would be the silent short list the design forbids, arriving by the back door.
 */
export function PlaylistScreen({ playlistId }: { playlistId: number }) {
  const navigate = useNavigate();
  const playlist = useResource(() => api.get<PlaylistDetail>(`/api/playlists/${playlistId}`), [playlistId]);

  if (playlist.error) return <Failed error={playlist.error} retry={playlist.reload} />;
  if (playlist.loading || !playlist.data) return <Loading what="the playlist" />;

  return (
    <Playlist
      key={playlist.data.id}
      playlist={playlist.data}
      onDelete={() =>
        void api.del(`/api/playlists/${playlistId}`).then(() => navigate({ to: "/playlists", search: {} }))
      }
      onRegenerate={() => void navigate({ to: "/playlists", search: { from: playlistId } })}
    />
  );
}
